import backend from '@/services/backend'

export default {

    createReportTask(authToken, realmName, studyName, reportName, drillPath) {
        const url = 'reports/createtask/'+realmName+'/'+studyName +'/'+reportName
        return backend({ method: 'post', url: url, data: { drillPath }, headers: { Authorization: authToken } })
    },

    requestReportInfos(authToken, realmName, studyName, reports) {
        const url = 'reports/reportinfos/'+realmName+'/'+studyName
        // console.log('requestReportInfos: ' + url)
        return backend({ method: 'post', url: url, data: { reports }, headers: { Authorization: authToken } })
    }

}
